<template>
  <div>
    <accettazione-ssn-impegnativa-modal-component ref="cmpAccettazioneImpegnativa" :isDematerializzata="false"
      :isEdit="isEdit" :prestazioni="jsonData.ricette" :idAccettazione="jsonData.id" :isFirstDematerializzata="false"
      :codiceFiscalePaziente="jsonData.accettazione.accettazioneAnagrafica.identificativo"
      @onAggiungiImpegnativa="onAggiungiImpegnativa" @onChangeTipologiaRicetta="onChangeTipologiaRicetta"
      @onModificaImpegnativaNuova="onModificaImpegnativaNuova" @onAggiungiImpegnativaBe="onAggiungiImpegnativaBe"
      @reload="onReload" />
    <b-card class="sa-card sa-card-border" header-tag="header" footer-tag="footer" title="" :key="keyCard">
      <template #header>
        <div class="d-flex justify-content-between align-items-center custom-header">
          <span>Impegnativa e dettaglio prestazioni</span>
          <b-button size="sm" variant="success" @click="onOpenModalImpegnativa()"
            :disabled="!isEdit">Aggiungi</b-button>
        </div>
      </template>
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">
        <b-col cols="12">
          <div class="b-table-sticky-header">
            <b-table sticky-header ref="table" stacked="lg" striped hover responsive :items="localData.ricette"
              :fields="headersImpegnative" :current-page="1" :per-page="100" sort-icon-left head-variant="light"
              class="sa-b-table" empty-text="no data">
              <template v-slot:cell(tipologia)="row">
                <span style="font-weight: 700; margin-right: 3px">{{ row.item.tipologia }}</span>
              </template>
              <template v-slot:cell(nre)="row">
                <span style="font-weight: 700; margin-right: 3px">{{ row.item.codiceBar1 }}{{ row.item.codiceBar2
                }}</span>
              </template>
              <template v-slot:cell(prestazioni)="row">
                <span style="font-weight: 700; margin-right: 3px">
                  {{ row.item.prestazioni ? row.item.prestazioni.length : 0 }}
                </span>
              </template>
              <template v-slot:cell(statoAttuale)="row">
                <span style="font-weight: 500; margin-right: 1px">{{ row.item.statoAttuale }}</span>
              </template>
              <template v-slot:cell(actions)="row">
                <b-container class="bv-example-row">
                  <b-button size="sm" v-b-tooltip.hover title="Modifica Ricetta"
                    :disabled="row.item.statoAttuale != 'PRESA IN CARICO'" variant="outline-primary"
                    @click="onClickModificaRicetta(row)">
                    <b-icon icon="pencil"></b-icon>
                  </b-button>
                  <b-button size="sm" v-b-tooltip.hover title="Prestazioni" variant="outline-primary"
                    @click="onClickStorico(row)">
                    <font-awesome-icon :icon="row.item._showDetails ? 'arrow-down' : 'arrow-left'" />
                  </b-button>
                  <b-button v-if="id != '-1' && row.item.prestazioni.length < 1" size="sm" v-b-tooltip.hover
                    title="Elimina Ricetta" variant="outline-danger" @click="onClickRimuoviRicetta(row)">
                    <font-awesome-icon :icon="'trash'" />
                  </b-button>
                </b-container>
              </template>
              <template #row-details>
                <b-row style="padding: 5px">
                  <b-col cols="12">
                    <b-table sticky-header ref="table1" stacked="lg" striped hover :items="itemsDetail"
                      :fields="headersPrestazioni" :current-page="1" :per-page="100" sort-icon-left head-variant="light"
                      class="sa-b-table">
                      <template v-slot:cell(quantita)="row">
                        <div v-if="row.item.new">
                          <b-form-input v-model="prestazione.quantita" type="number"></b-form-input>
                        </div>
                        <div v-else>
                          <b-form-input v-if="!isRowEdit(row)" v-model="selectedRowEditItem.quantita"
                            type="number"></b-form-input>
                          <span v-else>{{ row.item.quantita }}</span>
                        </div>
                      </template>
                      <template v-slot:cell(appuntamenti)="row">
                        <template v-if="!row.item.new">
                          <div
                            style="flex: 1; display: flex; justify-content: start; align-items: start; gap: 6px; font-size: 12px">
                            <span class="badge" :style="{
                              minWidth: '18px',
                              height: '18px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '50%',
                              background: getColorBackGround(row),
                              color: 'white',
                              fontWeight: '600',
                              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            }">
                              {{ row.item.appuntamenti ? row.item.appuntamenti.length : 0 }}
                            </span>
                            <span style="font-weight: 800">/</span>
                            <span class="badge"
                              style="min-width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background: #00a3ff; color: white; font-weight: 600; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)">
                              {{ row.item.quantita }}
                            </span>
                          </div>
                          <div v-if="row.item.appuntamentiTmp ? row.item.appuntamentiTmp.length > 0 : false">
                            <div
                              style="flex: 1; display: flex; justify-content: start; align-items: start; gap: 6px; font-size: 12px">
                              <span style="font-weight: 600">Selezionati </span>
                              <span :style="{
                                color: '#00a3ff',
                                fontWeight: 600,
                              }">
                                {{ row.item.appuntamentiTmp.length }}
                              </span>
                              <span style="font-weight: 600"> di {{ row.item.quantita }}</span>
                            </div>
                            <span v-for="(item, i) of row.item.appuntamentiTmp" :key="i">
                              <span :style="{
                                color: '#00a3ff',
                                fontWeight: 600,
                              }">
                                {{ i + 1 }}
                              </span>
                              <span style="font-weight: 600">{{ getOrario(item.dataOraInizio) }} - {{
                                getOrario(item.dataOraFine) }}</span>
                            </span>
                          </div>
                        </template>
                      </template>
                      <template v-slot:cell(listino)="row">
                        <div v-if="row.item.new">
                          <b-form-select v-model="prestazione.idListino" :disabled="true" :options="listinoOptions"
                            value-field="value" text-field="text">
                            <template #first>
                              <b-form-select-option disabled :value="null">Seleziona</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>
                        <div v-else>
                          <b-form-select v-model="selectedRowEditItem.idListino" :disabled="true"
                            :options="listinoOptions" value-field="value" text-field="text" v-if="!isRowEdit(row)">
                            <template #first>
                              <b-form-select-option disabled :value="null">Seleziona</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span v-else>
                            {{ getListinoText(row.item.idListino) }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:cell(descrizionePrestazione)="row">
                        <div v-if="row.item.new">
                          <div>
                            <b-form-input v-model="prestazione.descrizionePrestazione" list="my-list-id"
                              :disabled="!isRowEdit(row)" @change="onChangePrestazione"></b-form-input>
                            <datalist id="my-list-id">
                              <option v-for="(item, i) in prestazioniOptions" :key="i">
                                {{ `${item.descrizionePrestazione} (${item.codicePrestazione})` }}
                              </option>
                            </datalist>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="!isRowEdit(row)">
                            <b-form-input v-model="selectedRowEditItem.descrizionePrestazione" list="my-list-id"
                              @change="onChangePrestazione"></b-form-input>
                            <datalist id="my-list-id">
                              <option v-for="(item, i) in prestazioniOptions" :key="i">
                                {{ `${item.descrizionePrestazione} (${item.codicePrestazione})` }}
                              </option>
                            </datalist>
                          </div>
                          <span v-else>
                            {{ row.item.descrizionePrestazione }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:cell(prezzo)="row">
                        <div v-if="row.item.new">
                          <b-form-input v-model="prestazione.prezzo" type="text" :disabled="true"></b-form-input>
                        </div>
                        <div v-else>
                          <b-form-input v-model="selectedRowEditItem.prezzo" type="text" :disabled="true"
                            v-if="!isRowEdit(row)"></b-form-input>
                          <span v-else>{{ row.item.prezzo }}€</span>
                        </div>
                      </template>
                      <template v-slot:cell(dataErogazione)="row">
                        <div v-if="row.item.new">
                          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="prestazione.dataErogazione"
                            type="date"></date-picker>
                        </div>
                        <span v-else>
                          <date-picker format="DD/MM/YYYY" value-type="timestamp"
                            v-model="selectedRowEditItem.dataErogazione" type="date"
                            v-if="!isRowEdit(row)"></date-picker>
                          <span v-else>
                            {{ formatDate(row.item.dataErogazione) }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:cell(statoAttuale)="row">
                        <span v-if="!row.item.new" style="font-weight: 700; margin-right: 3px">
                          {{ row.item.statoAttuale }}
                        </span>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <div v-if="row.item.new && selectedRowEditIndex == null">
                          <b-container class="bv-example-row">
                            <b-button :disabled="isBtnAggiungiPrestazioneDisabled() || !isEdit" size="sm"
                              v-b-tooltip.hover title="Aggiungi Prestazione" variant="outline-success"
                              @click="onAggiungiPrestazione(row)">
                              <font-awesome-icon icon="plus" />
                            </b-button>
                          </b-container>
                        </div>
                        <div v-else>
                          <b-container class="bv-example-row">
                            <div v-if="!isRowEdit(row)">
                              <b-button size="sm" v-b-tooltip.hover title="Conferma Modifica" variant="outline-info"
                                @click="onConfermaModificaPrestazione(row)">
                                <font-awesome-icon icon="check" />
                              </b-button>
                              <b-button size="sm" v-b-tooltip.hover title="Annulla Modifica" variant="outline-danger"
                                @click="onAnnullaModifica(row)">
                                <font-awesome-icon icon="times" />
                              </b-button>
                            </div>
                            <b-button size="sm" v-if="isTastoVisibile('Prenota Visita', row)" v-b-tooltip.hover
                              :disabled="isBtnDisabled('Prenota Visita', row)" title="Prenota Visita"
                              variant="outline-primary" @click="onPrenotaAppuntamento(row)">
                              <font-awesome-icon icon="calendar" />
                            </b-button>
                            <template>
                              <b-button size="sm" v-if="isTastoVisibile('Visualizza Prenotazione', row)"
                                v-b-tooltip.hover title="Visualizza Prenotazione/i" variant="outline-primary"
                                @click="onVisualizzaPrenotazione(row)">
                                <font-awesome-icon icon="calendar-check" />
                              </b-button>
                              <b-button size="sm" v-if="isTastoVisibile('Modifica Prenotazione', row)" v-b-tooltip.hover
                                title="Modifica Prenotazione" variant="outline-primary"
                                @click="onModificaPrenotazione(row)">
                                <font-awesome-icon icon="calendar" />
                              </b-button>
                              <!-- <b-button v-if="row.item.appuntamentiTmp ? row.item.appuntamentiTmp.length > 0 : false" size="sm" v-b-tooltip.hover title="Sblocca Slot" variant="outline-danger" @click="onSbloccoSlot(row)">
                                <font-awesome-icon icon="calendar" />
                              </b-button> -->
                            </template>
                            <b-button size="sm" v-if="selectedRowEditIndex == null && isRowEdit(row)"
                              :disabled="!isEdit || isBtnDisabled('Modifica Prestazione', row) || row.item.statoAttuale != 'PRESA IN CARICO'"
                              v-b-tooltip.hover title="Modifica Prestazione" variant="outline-info"
                              @click="onModificaPrestazione(row)">
                              <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button v-if="selectedRowEditIndex == null" size="sm"
                              :disabled="!isEdit || isBtnDisabled('Rimuovi Prestazione', row) || row.item.statoAttuale != 'PRESA IN CARICO'"
                              v-b-tooltip.hover title="Rimuovi Prestazione" variant="outline-danger"
                              @click="onEliminaPrestazione(row)">
                              <font-awesome-icon icon="trash" />
                            </b-button>
                          </b-container>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal ref="mdlPrenotazionePrestazione" id="mdlPrenotazionePrestazione" @show="onShowModal" scrollable size="xl"
      style="height: 100%" title="Disponibilita Agenda" @hide="onHideModalPrenotazione">
      <b-row style="margin-bottom: 15px">
        <b-col cols="12" style="margin-bottom: 5px" v-if="tab == 1">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 1</span>

            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Seleziona Disponibilita</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" style="margin-bottom: 5px" v-if="tab == 2">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 2</span>

            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Conferma Appuntamenti</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2">
          <label class="sa-label_data">Agenda</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="idAgenda" class="mb-2 mr-sm-2 mb-sm-0"
            :options="agendeOptions" value-field="id" text-field="titolo" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <label class="sa-label_data">Data Riferimento <font-awesome-icon icon="calendar-day" style="cursor: pointer"
              @click="onTornaAdOggi()" /></label>
          <div style="display: flex">
            <font-awesome-icon icon="arrow-circle-left"
              style="height: 28px; width: 28px; justify-content: start; margin-right: 2px; cursor: pointer"
              @click="indietro()" />
            <b-form-input v-model="dataRiferimento" :disabled="true"></b-form-input>
            <font-awesome-icon icon="arrow-circle-right"
              style="height: 28px; width: 28px; margin-left: 2px; cursor: pointer" @click="avanti()" />
          </div>
        </b-col>
        <b-col xs="12" sm="12" md="2" lg="2" xl="2">
          <label class="sa-label_data">Modalita Visualizzazione</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group id="radio-group-2" v-model="periodoAgenda" :aria-describedby="ariaDescribedby"
              name="radio-sub-component">
              <b-form-radio value="W">Settimana</b-form-radio>
              <b-form-radio value="G">Giorno</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <label class="sa-label_data">Slot Selezionati / Slot Totali Prenotazione </label>
          <div style="flex: 1; display: flex; justify-content: start; align-items: start; gap: 6px; font-size: 12px">
            <span class="badge" :style="styleBadgeForDisponibilitaSelezionate">
              {{ disponbilitaSelezionate.length }}
            </span>
            <span style="font-weight: 800">/</span>
            <span class="badge"
              style="min-width: 22px; height: 22px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background: #00a3ff; color: white; font-weight: 600; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)">
              {{ selectedRowPrenotazione == null ? 0 : selectedRowPrenotazione.item.quantita }}
            </span>
          </div>
        </b-col>
      </b-row>
      <template v-if="tab == 1">
        <template v-for="(giorni, i) in disponibilitaAgenda">
          <b-row v-if="periodoAgenda == 'G'" :key="i" style="display: flex; justify-content: center">
            <b-col cols="3" v-for="(disponibilita, i) in giorni.disponibilita" :key="i"
              style="cursor: pointer; margin: 3px">
              <b-card :class="{ ftActiveClass: isActiveClassCard(disponibilita), 'ft-card': true }"
                @click="onClickDisponibilita(disponibilita)">
                <b-card-text
                  style="font-weight: bold; font-size: medium; height: 100%; width: 100%; display: flex; justify-content: center"
                  class="align-middle">{{ disponibilita.dalleOre }} - {{ disponibilita.alleOre }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="periodoAgenda == 'W'" style="display: flex; justify-content: center" :key="i">
            <b-col cols="3" v-for="(disponibilita, i) in giorni.disponibilita" :key="i"
              style="cursor: pointer; margin: 3px">
              <b-card :class="{ ftActiveClass: isActiveClassCard(disponibilita), 'ft-card': true }"
                @click="onClickDisponibilita(disponibilita)"
                :style="{ display: 'flex', justifyContent: 'center', alignItems: 'center' }">
                <b-card-text style="font-weight: bold; font-size: medium">{{ disponibilita.dalleOre }} - {{
                  disponibilita.alleOre }}</b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-if="tab == 2">
        <b-row style="display: flex; justify-content: center">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px">
            <span class="font-weight-bold" style="font-size: large"> Appuntamento/i Selezionato/i</span> <br />
            <small> {{ selectedRowPrenotazione.item.descrizionePrestazione }}</small>
          </b-col>
          <b-col v-for="(selezione, index) in disponbilitaSelezionate" :key="index" cols="2"
            style="margin: 1px; text-align: center">
            <b-card class="ft-card">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: large">{{ getDataSistoFormat(selezione.dataRiferimento)
                }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ selezione.dalleOre }} - {{ selezione.alleOre
                }}</div>
              </b-card-text>
              <b-card-text style="text-align: center; align-items: center">
                <b-button v-if="selezione.id" size="sm" :disabled="isBeforeDate(selezione)" v-b-tooltip.hover
                  title="Rimuovi appuntamento" variant="danger"
                  @click="onClickRimuoviAppuntamentoSelezionatoBe(selezione)"><font-awesome-icon
                    icon="trash" /></b-button>
                <b-button v-if="!selezione.id" size="sm" :disabled="isBeforeDate(selezione)" v-b-tooltip.hover
                  title="Elimina e Seleziona Nuovo Appuntamento" style="background-color: #00a3ff"
                  @click="onClickModificaAppuntamentoSelezionato(selezione)"> <font-awesome-icon
                    icon="edit" /></b-button>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template v-else></template>
      <template #modal-footer>
        <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
          <b-button variant="primary" v-if="tab == 2" @click="tab = 1">Indietro</b-button>
          <b-button variant="success" v-if="tab == 1" @click="tab = 2"> Avanti </b-button>
          <b-button variant="secondary" v-if="tab == 1" @click="closeModal()">Chiudi</b-button>

          <b-button variant="success" v-if="tab == 2 && !isNuovaAccettazione" @click="onOkConfermaAppuntamento()">
            Prenota </b-button>
          <!-- <b-button variant="success" v-if="tab == 2 && selectedRowPrenotazione.item.id != '-1'" @click="onPrenotaAppuntamentoNuovaAccettazione()"> Occupa Slot Prestazione </b-button> -->
        </div>
      </template>
    </b-modal>
    <b-modal ref="mdlVisualizzaPrenotazione" id="mdlVisualizzaPrenotazione" size="large"
      style="height: 100%; width: 100%" title="Appuntamento">
      <template v-if="appuntamentoView != null">
        <b-row style="display: flex; justify-content: center">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px"> <span class="font-weight-bold"
              style="font-size: large"> Appuntamento/i Selezionato/i</span> <br /> </b-col>
          <b-col v-for="(selezione, index) in appuntamentoView" :key="index" cols="auto"
            style="margin: 1px; text-align: center">
            <b-card class="ft-card" style="height: 100%; width: 100%">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: large">{{ getDataSistoFormat(selezione.dataRiferimento)
                }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ getOrario(selezione.dataOraInizio) }} - {{
                  getOrario(selezione.dataOraFine) }}</div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeModalViewAppuntamento()">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaModalComponent from "./AccettazioneSsnImpegnativaModalComponent.vue";
import moment from "moment";
import axios from "axios";

export default {
  components: { DatePicker, AccettazioneSsnImpegnativaModalComponent },
  mixins: [UtilityMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    idAccettazione: {
      type: String,
      default: () => {
        return null;
      },
    },
    isDematerializzata: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    ricette: {
      type: Array,
      required: true,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      tab: 1,
      id: null,
      keyCard: 0,
      listinoOptions: [{ text: "LISTINO REGIONALE SSN", value: "LISTINOREGIONALESSN" }],
      prestazioniOptions: [],
      localData: {
        ricette: [],
      },
      disponibilitaAgendaItems: [],
      itemsDetail: [],
      agendeOptions: [],
      selectedRowDetail: null,
      selectedRowDetailIndex: null,

      selectedRowEditIndex: null,
      selectedRowEditItem: null,

      selectedRowPrenotazione: null,
      appuntamentoAgendaSlot: null,
      ricettaSelezionataRow: null,
      disponbilitaSelezionate: [],
      idAgenda: null,
      periodoAgenda: "G",
      isNuovaAccettazione: false,
      pathResourcePrestazioni: "/agendaprestazioni/presidio",
      pathResource: "/accettazionericetteprestazioni",
      pathResourceRicetta: "/accettazionericette",
      pathResourceAgenda: "/agende/prestazione",
      pathResourceAgendaDisponibilita: "/agendadisponibilita",
      pathResourceAgendaAppuntamento: "/agendaappuntamenti",
      dataRiferimento: "",
      appuntamentoView: [],
      prestazione: {
        id: "-1",
        quantita: 1,
        idListino: "LISTINOREGIONALESSN",
        descrizionePrestazione: null,
        codicePrestazione: null,
        statoAttuale: "PRESA IN CARICO",
        prezzo: 0,
        dataErogazione: null,
        new: true,
        appuntamenti: [],
        appuntamentiTmp: [],
      },
      selectedCheckBoxs: [],
      presRegioniOptions: [],
      optionsCheckBoxGroup: [
        { text: "Anonimato", value: "anonimato" },
        { text: "STP", value: "stp" },
        { text: "ENI", value: "eni" },
        { text: "Conv", value: "conv" },
        { text: "TEAM", value: "team" },
        { text: "Cons", value: "cons" },
        { text: "Email", value: "emailBox" },
        { text: "Sconosciuto", value: "sconosciuto" },
      ],
      headersPrestazioni: [
        {
          label: "Numero Prestazioni",
          key: "quantita",
          thStyle: "width: 10rem",
        },
        /*  {
          label: "Listino",
          key: "listino",
        },*/
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
        },
        {
          label: "Prezzo",
          key: "prezzo",
          thStyle: "width: 4rem",
        },
        {
          label: "",
          key: "statoAttuale",
        },
        {
          label: "Importo",
          key: "importo",
          thStyle: "width: 3rem",
        },
        {
          label: "Appuntamenti Prenotati",
          key: "appuntamenti",
          thStyle: "width: 12rem",
        },
        /**    {
          label: "Data Erogazione",
          key: "dataErogazione",
        },*/
        {
          label: "",
          key: "actions",
          tdClass: "sa-table-column-action-double",
        },
      ],
      headersImpegnative: [
        {
          label: "Tipologia",
          key: "tipologiaRicetta",
        },
        {
          label: "Priorità",
          key: "classePriorita",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "Stato Ricetta",
          key: "statoAttuale",
        },
        {
          label: "Quantita",
          key: "prestazioni",
        },
        {
          label: "",
          key: "actions",
          tdClass: "text-right",
        },
      ],

      styleBadgeForDisponibilitaSelezionate: {
        minWidth: "22px",
        height: "22px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        background: "#ffc107",
        color: "white",
        fontWeight: "600",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      },
    };
  },

  computed: {
    prestazioni() {
      let me = this;
      return new Set(me.prestazioniOptions);
    },

    disponibilitaAgenda() {
      let me = this;
      let returnValue = [
        {
          giorno: me.dataRiferimento,
          disponibilita: [],
        },
      ];
      if (me.disponibilitaAgendaItems != null)
        if (me.disponibilitaAgendaItems[0]) {
          let disponibilita = me.disponibilitaAgendaItems[0].disponibilita;
          for (let dis of disponibilita) {
            let listaAccessi = dis.appuntamento.length;
            for (let i = 0; i < listaAccessi; i++) {
              let slotDisp = false;
              if (dis.appuntamento[i] === null) {
                slotDisp = true;
              }
              if (slotDisp) {
                const dataI = new Date(`${dis.dataRiferimento}T${dis.dalleOre}`);
                if (new Date() < dataI) {
                  returnValue[0].disponibilita.push(dis);
                }
              }
            }
          }

          returnValue[0].disponibilita = new Set(returnValue[0].disponibilita);
        }
      console.log(returnValue[0].disponibilita);

      return returnValue;
    },
  },
  mounted() {
    let me = this;
    me.isDematerializzata ? (me.localData.tipologiaRicetta = "DEMATERIALIZZATA") : null;
    me.selectedRowDetail = null;
    me.selectedRowEditIndex = null;
    me.selectedRowEditItem = null;
    me.dataRiferimento = moment(new Date().getTime()).format("YYYY-MM-DD");
    me.setJsonData();
    me.loadPrestazioni();
    if (this.idAccettazione == null) {
      if (this.$route.params.id == "-1") {
        me.isNuovaAccettazione = true;
      }
    } else if (this.idAccettazione == "-1") {
      me.isNuovaAccettazione = true;
    }

    console.log("nuova accettazione", me.isNuovaAccettazione);
  },

  watch: {
    disponbilitaSelezionate: function (params) {
      if (params && this.selectedRowPrenotazione)
        if (params.length == this.selectedRowPrenotazione.item.quantita) {
          this.styleBadgeForDisponibilitaSelezionate.background = "#00a3ff";
        } else {
          this.styleBadgeForDisponibilitaSelezionate.background = "#ffc107";
        }
    },
    ricette: function () {
      this.setJsonData();
    },
    dataRiferimento: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    periodoAgenda: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    idAgenda: function (params) {
      let me = this;
      if (params) {
        me.loadAgendaDisponibilita();
      }
    },
    "prestazione.quantita": function (params) {
      let me = this;
      if (params >= 1 && me.prestazione.descrizionePrestazione != null) {
        let filter = me.prestazioniOptions.filter((a) => a.descrizionePrestazione === me.prestazione.descrizionePrestazione);
        let prezzoPrestazione = filter[0].costo;
        me.prestazione.prezzo = prezzoPrestazione * params;
      }
    },
    "prestazione.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        const match = params.match(/\(([^)]+)\)/);
        if (match) {
          let mathc = match[1];
          let filter = me.prestazioniOptions.filter((a) => a.codicePrestazione === mathc);
          let prezzoPrestazione = filter[0].costo;
          me.prestazione.prezzo = prezzoPrestazione * me.prestazione.quantita;
        }
      }
    },
    "selectedRowEditItem.quantita": function (params) {
      let me = this;
      if (params >= 1 && me.selectedRowEditItem.descrizionePrestazione != null) {
        let filter = me.prestazioniOptions.filter((a) => a.descrizionePrestazione === me.selectedRowEditItem.descrizionePrestazione);
        let prezzoPrestazione = filter[0].costo;
        me.selectedRowEditItem.prezzo = prezzoPrestazione * params;
      }
    },
    "selectedRowEditItem.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        let filter = me.prestazioniOptions.filter((a) => a.descrizionePrestazione === params);
        let prezzoPrestazione = filter[0].costo;
        me.selectedRowEditItem.prezzo = prezzoPrestazione * me.selectedRowEditItem.quantita;
      }
    },
  },
  methods: {
    onClickRimuoviRicetta(row) {
      console.log(row);
    },
    isTastoVisibile(action, row) {
      let me = this;
      switch (action) {
        case "Prenota Visita":
          return !me.isNuovaAccettazione && !row.item.new && me.selectedRowEditIndex == null && !row.item.appuntamenti.find((e) => e.id != "-1");
        case "Visualizza Prenotazione":
          return row.item.appuntamenti.length > 0;
        case "Modifica Prenotazione":
          return !me.isNuovaAccettazione && !row.item.new && row.item.appuntamenti.find((e) => e.id != "-1");
        default:
          break;
      }
      //;
    },
    isBtnDisabled(btntitle, row) {
      let me = this;
      let esito = false;
      if (me.isNuovaAccettazione) {
        switch (btntitle) {
          case "Rimuovi Prestazione":
            esito = row.item.appuntamentiTmp ? row.item.appuntamentiTmp.length > 0 : false;
            if (row.item.statoAttuale != "PRESA IN CARICO") {
              return true;
            }
            break;
          case "Modifica Prestazione":
          case "Prenota Visita":
            esito = row.item.appuntamentiTmp ? row.item.appuntamentiTmp.length > 0 : false;
            break;

          default:
            break;
        }
      }
      return esito;
    },
    getColorBackGround(row) {
      let color = "#b6b5b5";
      if (row.item) {
        if (row.item.appuntamenti) {
          color = row.item.appuntamenti.length == row.item.quantita ? "#00a3ff" : "#ffc107";
        }
      }
      return color;
    },

    onModificaImpegnativaNuova(ricetta, index) {
      this.localData.ricette[index] = ricetta;
      this.$refs.cmpAccettazioneImpegnativa.hide();
    },

    isBeforeDate(slot) {
      const dataA = new Date(`${slot.dataRiferimento}T${slot.dalleOre}`);
      return new Date() > dataA;
    },

    onClickModificaAppuntamentoSelezionato(slot) {
      let me = this;
      me.disponbilitaSelezionate.splice(me.disponbilitaSelezionate.indexOf(slot), 1);
      me.disponbilitaSelezionate = me.disponbilitaSelezionate.sort((a, b) => {
        const dataA = new Date(`${a.dataRiferimento}T${a.dalleOre}`);
        const dataB = new Date(`${b.dataRiferimento}T${b.dalleOre}`);
        return dataA - dataB;
      });
      me.tab = 1;
    },
    onClickRimuoviAppuntamentoSelezionato(slot) {
      let me = this;
      me.disponbilitaSelezionate.splice(me.disponbilitaSelezionate.indexOf(slot), 1);
      me.disponbilitaSelezionate = me.disponbilitaSelezionate.sort((a, b) => {
        const dataA = new Date(`${a.dataRiferimento}T${a.dalleOre}`);
        const dataB = new Date(`${b.dataRiferimento}T${b.dalleOre}`);
        return dataA - dataB;
      });
      me.emitChange();
    },
    onClickRimuoviAppuntamentoSelezionatoBe(slot) {
      let me = this;
      axios
        .delete(process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento" + "/" + slot.id)
        .then((response) => {
          console.log("log response", response);
          me.$refs.mdlPrenotazionePrestazione.hide();
          me.$emit("reload");

          me.tab = 1;
          me.selectedRowDetail.toggleDetails();
        })
        .catch((err) => {
          err;
        });
    },

    isActiveClassCard(disponibilita) {
      return this.disponbilitaSelezionate.some((e) => {
        let a = e.alleOre === disponibilita.alleOre;
        let b = e.dalleOre === disponibilita.dalleOre;
        let c = e.dataRiferimento === disponibilita.dataRiferimento;
        return a && b && c;
      });
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    getDataSistoFormat(data) {
      let date = new Date(data);
      return moment(date).format("DD-MM-YYYY");
    },
    closeModalViewAppuntamento() {
      let me = this;
      me.$refs.mdlVisualizzaPrenotazione.hide();
    },
    onShowModal() {
      // let me = this;
      // me.disponbilitaSelezionate = null;
    },
    onClickModificaRicetta(row) {
      let me = this;
      me.ricettaSelezionataRow = row;
      me.$refs.cmpAccettazioneImpegnativa.setRicettaModificare(me.ricettaSelezionataRow);
      me.$refs.cmpAccettazioneImpegnativa.show();
    },

    async onModificaPrenotazione(row) {
      let me = this;
      me.selectedRowPrenotazione = row;
      let appuntamenti = [];
      if (row.item.appuntamenti) {
        if (row.item.appuntamenti.length > 0) {
          for (let prenotazione of row.item.appuntamenti) {
            await me.loadAppuntamentoId(prenotazione.id);
            let appuntamento = me.appuntamentoAgendaSlot;
            let dataOraFineTimestamp = appuntamento.dataOraFine;
            let dataOraInizioTimestamp = appuntamento.dataOraInizio;
            let obj = {
              idPrestazione: appuntamento.idEsterno,
              id: appuntamento.id ? appuntamento.id : "-1",
              alleOre: moment(dataOraFineTimestamp).format("hh:mm"),
              appuntamento: [],
              clsIntervallo: null,
              dalleOre: moment(dataOraInizioTimestamp).format("hh:mm"),
              dataRiferimento: appuntamento.dataRiferimento,
              extraTime: true,
              titolo: "",
            };
            appuntamenti.push(obj);
          }
        }
      }
      me.disponbilitaSelezionate = appuntamenti;
      me.loadAgende();
      me.tab = me.disponbilitaSelezionate.length == 0 ? 1 : 2;
      me.$refs.mdlPrenotazionePrestazione.show();
    },

    onPrenotaAppuntamento(row) {
      let me = this;
      me.selectedRowPrenotazione = row;
      let appuntamenti = [];
      if (row.item.appuntamentiTmp) {
        if (row.item.appuntamentiTmp.length > 0) {
          for (let prenotazione of row.item.appuntamentiTmp) {
            appuntamenti.push(prenotazione);
          }
        }
      }
      me.disponbilitaSelezionate = appuntamenti;
      me.loadAgende();
      me.$refs.mdlPrenotazionePrestazione.show();
    },
    onClickDisponibilita(item) {
      let me = this;
      if (me.isActiveClassCard(item)) {
        me.disponbilitaSelezionate.splice(me.disponbilitaSelezionate.indexOf(item), 1);
      } else {
        if (me.disponbilitaSelezionate.length < this.selectedRowPrenotazione.item.quantita) {
          me.disponbilitaSelezionate.push(item);
        }
      }
      me.disponbilitaSelezionate = me.disponbilitaSelezionate.sort((a, b) => {
        const dataA = new Date(`${a.dataRiferimento}T${a.dalleOre}`);
        const dataB = new Date(`${b.dataRiferimento}T${b.dalleOre}`);
        return dataA - dataB;
      });
    },
    onSbloccoSlot(row) {
      row.item.appuntamentiTmp = [];
      this.onAnnullaSelezionato();
    },
    onAnnullaSelezionato() {
      let me = this;
      me.tab = 1;
      me.disponbilitaSelezionate = [];
    },

    onVisualizzaPrenotazione(row) {
      let me = this;
      me.appuntamentoView = row.item.appuntamenti;
      me.$refs.mdlVisualizzaPrenotazione.show();
    },
    async loadAppuntamentoId(id) {
      let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento" + "/" + id;
      await axios
        .get(link)
        .then(async (response) => {
          let respon = await response.data.data;
          console.log(respon);
          this.appuntamentoAgendaSlot = respon;
        })
        .catch((error) => {
          error;
          //resultError(error);
        });
    },

    loadAppuntamentoById(id) {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceAgendaAppuntamento + "/" + id, null, me.loadAppuntamentoByIdSuccess, me.loadAppuntamentoByIdError);
    },
    loadAppuntamentoByIdSuccess(response) {
      let me = this;
      me.appuntamentoView.push(response.data.data);
    },
    loadAppuntamentoByIdError(error) {
      console.log(error);
    },

    onPrenotaAppuntamentoNuovaAccettazione() {
      let me = this;
      for (let disponibilita of me.disponbilitaSelezionate) {
        let dataOraInizio = new Date(disponibilita.dataRiferimento + " " + disponibilita.dalleOre).getTime();
        let dataOraFine = new Date(disponibilita.dataRiferimento + " " + disponibilita.alleOre).getTime();

        let appuntamentoAgenda = {
          idAgenda: me.idAgenda,
          cognome: me.jsonData.accettazioneAnagrafica ? me.jsonData.accettazioneAnagrafica.cognome : "",
          tipoIdentificativo: "CF",
          identificativoAppuntamento: me.jsonData.accettazioneAnagrafica ? me.jsonData.accettazioneAnagrafica.identificativo : "",
          codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione,
          descrizionePrestazione: me.selectedRowPrenotazione.item.descrizionePrestazione,
          dataOraInizio: dataOraInizio,
          dataOraFine: dataOraFine,
          dataRiferimento: disponibilita.dataRiferimento,
          costo: me.selectedRowPrenotazione.item.prezzo,
          nome: me.jsonData.accettazioneAnagrafica ? me.jsonData.accettazioneAnagrafica.nome : "",
          dataNascita: null,
          note: null,
        };
        me.selectedRowPrenotazione.item.appuntamentiTmp.push(JSON.parse(JSON.stringify(appuntamentoAgenda)));
      }
      me.closeModal();
    },
    onTornaAdOggi() {
      let me = this;
      let dataAttuale = new Date();
      me.dataRiferimento = moment(dataAttuale).format("YYYY-MM-DD");
    },

    onOkConfermaAppuntamento() {
      let me = this;

      for (let disponibilita of me.disponbilitaSelezionate) {
        if (!disponibilita.id) {
          let dataOraInizio = new Date(disponibilita.dataRiferimento + " " + disponibilita.dalleOre).getTime();
          let dataOraFine = new Date(disponibilita.dataRiferimento + " " + disponibilita.alleOre).getTime();
          let appuntamentoAgenda = {
            idAgenda: me.idAgenda,
            cognome: me.jsonData.accettazione.accettazioneAnagrafica.cognome,
            tipoIdentificativo: "CF",
            identificativoAppuntamento: me.jsonData.accettazione.accettazioneAnagrafica.identificativo,
            codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione,
            descrizionePrestazione: me.selectedRowPrenotazione.item.descrizionePrestazione,
            dataOraInizio: dataOraInizio,
            dataOraFine: dataOraFine,
            dataRiferimento: disponibilita.dataRiferimento,
            costo: me.selectedRowPrenotazione.item.prezzo,
            nome: me.jsonData.accettazione.accettazioneAnagrafica.nome,
            dataNascita: null,
            note: null,
          };
          me.selectedRowPrenotazione.item.appuntamenti.push(JSON.parse(JSON.stringify(appuntamentoAgenda)));
        }
      }
      delete me.selectedRowDetail.item._showDetails;
      UtilityMixin.methods.restCallPut(process.env.VUE_APP_PATH_API + me.pathResourceRicetta + "/" + me.selectedRowDetail.item.id, me.selectedRowDetail.item, me.onSalvaPrenotazione, me.onSalvaPrenotazioneError);
    },
    onSalvaPrenotazione(response) {
      let me = this;
      response;
      me.closeModal();
      me.selectedRowDetail.toggleDetails();
      //me.selectedRowPrenotazione.toggleDetails();
      me.$bvToast.toast("Salvataggio Appuntamento Avvenuta con successo", {
        title: "Operazione Avvenuta con Successo",
        variant: "success",
        solid: true,
      });
      me.$emit("reload");
    },
    onAggiungiImpegnativaBe() {
      let me = this;
      me.$emit("reload");
    },
    onReload() {
      console.log("reload");
      this.$emit("reload");
    },
    onSalvaPrenotazioneError(error) {
      console.log(error);
    },
    closeModal() {
      let me = this;
      me.$refs.mdlPrenotazionePrestazione.hide();
    },
    loadPrestazioni() {
      let me = this;
      me.prestazioniOptions = [];
      UtilityMixin.methods.loadDataResources(me.pathResourcePrestazioni, { idPresidio: me.jsonData.accettazione.idPresidio }, me.loadPrestazioniSuccess, me.loadPrestazioniError);
    },
    loadPrestazioniSuccess(response) {
      let me = this;
      me.prestazioniOptions = response.data.data;
    },
    loadPrestazioniError(error) {
      console.log(error);
    },
    loadAgende() {
      let me = this;
      me.agendeOptions = [];
      console.log(me.selectedRowPrenotazione);

      UtilityMixin.methods.loadDataResources(me.pathResourceAgenda, { idPresidio: me.jsonData.accettazione.idPresidio, codicePrestazione: me.selectedRowPrenotazione.item.codicePrestazione }, me.loadAgendeSuccess, me.loadAgendeError);
    },
    loadAgendeSuccess(response) {
      let me = this;
      me.agendeOptions = response.data.data;
    },
    loadAgendeError(error) {
      console.log(error);
    },
    loadAgendaDisponibilita() {
      let me = this;

      if (me.selectedRowPrenotazione) {
        let itemFIlter = {
          language: "it",
          idAgenda: me.idAgenda,
          periodo: me.periodoAgenda,
          riferimento: me.dataRiferimento,
          codicePrestazione: this.selectedRowPrenotazione.item.codicePrestazione,
        };
        me.disponibilitaAgendaItems = [];
        UtilityMixin.methods.loadDataResources(me.pathResourceAgendaDisponibilita, itemFIlter, me.loadAgendaDisponibilitaSuccess, me.loadAgendaDisponibilitaError);
      }
    },
    loadAgendaDisponibilitaSuccess(response) {
      let me = this;
      me.disponibilitaAgendaItems = response.data.data;
    },
    loadAgendaDisponibilitaError(error) {
      console.log(error);
    },
    indietro() {
      let me = this;
      switch (me.periodoAgenda) {
        case "G":
          me.dataRiferimento = moment(me.dataRiferimento).subtract(1, "days").format("YYYY-MM-DD");
          break;
        case "W":
          me.dataRiferimento = moment(me.dataRiferimento).subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    },
    avanti() {
      let me = this;
      switch (me.periodoAgenda) {
        case "G":
          me.dataRiferimento = moment(me.dataRiferimento).add(1, "days").format("YYYY-MM-DD");
          break;
        case "W":
          me.dataRiferimento = moment(me.dataRiferimento).add(1, "weeks").format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    },
    setJsonData() {
      let me = this;
      me.localData.ricette = me.ricette;
    },
    onChangeTipologiaRicetta(tipologia) {
      this.$emit("onIsTipologiaDematerilizzata", tipologia === "DEMATERIALIZZATA");
    },
    onAggiungiImpegnativa(json) {
      let me = this;
      me.$emit("onAggiungiImpegnativa", json);
    },

    isBtnAggiungiPrestazioneDisabled() {
      if (this.prestazione.descrizionePrestazione == null) {
        return true;
      }
      return false;
    },
    isRowEdit(row) {
      let me = this;
      return row == null ? true : row.index == me.selectedRowEditIndex ? false : true;
    },
    emitChange() {
      let me = this;
      me.$emit("updateJsonRicette", me.localData.ricette);
    },
    onChangePrestazione(value) {
      let me = this;
      console.log(value);
      const match = value.match(/\(([^)]+)\)/);
      if (match) {
        console.log(match[1]); // Output: "ABC123"
        let mathc = match[1];

        let prestazione = me.prestazioniOptions.find((p) => p.codicePrestazione == mathc);
        console.log(prestazione);

        if (prestazione != null)
          if (me.selectedRowEditItem == null) {
            me.prestazione.codicePrestazione = prestazione.codicePrestazione;
            me.prestazione.prezzo = prestazione.costo * Number(me.prestazione.quantita);
          } else {
            me.selectedRowEditItem.codicePrestazione = prestazione.codicePrestazione;
            me.selectedRowEditItem.prezzo = prestazione.costo * Number(me.prestazione.quantita);
          }
      }
    },
    onModificaPrestazione(row) {
      let me = this;
      if (me.selectedRowEditIndex == null) {
        me.selectedRowEditIndex = row.index;
        me.selectedRowEditItem = JSON.parse(JSON.stringify(row.item));
      }
    },
    onAnnullaModifica() {
      let me = this;
      me.selectedRowEditIndex = null;
      me.selectedRowEditItem = null;
    },

    onClickStorico(row) {
      let me = this;

      if (me.selectedRowDetail != null) {
        if (me.selectedRowDetail.index === row.index) {
          me.selectedRowDetail.toggleDetails();
          if (row.detailsShowing) {
            me.selectedRowDetail = null;
            me.itemsDetail = [];
            me.selectedRowEditIndex = null;
            me.selectedRowEditItem = null;
          }
          return;
        } else {
          me.selectedRowDetail.toggleDetails();
          me.selectedRowEditIndex = null;
          me.selectedRowEditItem = null;
        }
      } else {
        row.toggleDetails();
      }

      me.selectedRowDetail = row;
      me.itemsDetail = [];
      me.loadPrestazioniImpegnativa(row.item);
    },
    loadPrestazioniImpegnativa(item) {
      let me = this;
      me.itemsDetail = [...item.prestazioni, me.prestazione];
    },
    onConfermaModificaPrestazione() {
      let me = this;
      if (me.selectedRowEditIndex != null) {
        me.$set(me.itemsDetail, me.selectedRowEditIndex, JSON.parse(JSON.stringify(me.selectedRowEditItem)));
        me.selectedRowEditIndex = null;
        me.selectedRowEditItem = null;
      }
      let ricettaSelezionataMod = me.localData.ricette.filter((e, index) => index == me.selectedRowDetail.index);
      ricettaSelezionataMod[0].prestazioni = me.itemsDetail.filter((e) => e.new != true);
      me.emitChange();
    },
    onOpenModalImpegnativa() {
      let me = this;
      me.$refs.cmpAccettazioneImpegnativa.init();
    },
    onEliminaPrestazione(row) {
      let me = this;
      me.itemsDetail.splice(row.index, 1);
      let ricettaSelezionataMod = me.localData.ricette.filter((e, index) => index == me.selectedRowDetail.index);
      ricettaSelezionataMod[0].prestazioni = me.itemsDetail.filter((e) => e.new != true);

      if (row.item.id != "-1") {
        axios
          .delete(process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + row.item.id)
          .then((response) => {
            console.log(response);
            me.$emit("reload");
          })
          .catch((e) => {
            e;
          });
      }
      me.emitChange();
    },
    onAggiungiPrestazione() {
      let me = this;
      let prestazione = JSON.parse(JSON.stringify(me.prestazione));
      delete prestazione.new;
      me.itemsDetail.pop();
      me.itemsDetail.push(prestazione);
      me.itemsDetail = [
        ...me.itemsDetail,
        {
          quantita: 1,
          idListino: "LISTINOREGIONALESSN",
          prezzo: 0,
          statoAttuale: "PRESA IN CARICO",
          descrizionePrestazione: null,
          codicePrestazione: null,
          dataErogazione: me.localData.dataInizioErogazione,
          new: true,
          appuntamenti: [],
          appuntamentiTmp: [],
        },
      ];
      me.prestazione = {
        quantita: 1,
        idListino: "LISTINOREGIONALESSN",
        prezzo: 0,
        statoAttuale: "PRESA IN CARICO",
        descrizionePrestazione: null,
        codicePrestazione: null,
        dataErogazione: me.localData.dataInizioErogazione,
        new: true,
        appuntamenti: [],
        appuntamentiTmp: [],
      };
      let ricetta = me.localData.ricette.filter((i, index) => index == me.selectedRowDetail.index);
      ricetta[0].prestazioni.push(prestazione);
      me.emitChange();
    },
    getListinoText(value) {
      let me = this;
      let listino = me.listinoOptions.find((listino) => listino.value === value);
      return listino ? listino.text : "";
    },
    onHideModalPrenotazione() {
      let me = this;
      me.tab = 1;
      me.disponbilitaSelezionate = [];
    },
  },
};
</script>

<style>
.ft-card {
  border: 1px solid #b6b5b5 !important;
  border-radius: 12px;
  padding: 2px;
  transition: all 0.1s linear;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  cursor: pointer;
}

.ft-card .card-body {
  padding: 5px !important;
}

.ft-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.ftActiveClass,
.ftActiveClass:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 2px solid #00a3ff !important;
  border-color: #00a3ff !important;
}
</style>
